export default __webpack_public_path__ + "static/media/guide.560ea918.png";